import {AfterViewInit, Component, OnDestroy, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {UntypedFormBuilder, UntypedFormControl, UntypedFormGroup} from '@angular/forms';
import {Subject, Subscription} from 'rxjs';
import {debounceTime} from 'rxjs/operators';
import {AlternativeDatatablesInterface} from '../../../../shared/alternative-datatables/alternative-datatables.interface';
import {AlternativeDatatablesComponent} from '../../../../shared/alternative-datatables/alternative-datatables.component';
import {JsonClientService} from '../../../../shared/json-client/index';
import {GoBackButtonService} from '../../../../services/go-back-button.service';
import {BreadcrumbsService} from '../../../../shared/breadcrumbs/services/index';

@Component({
    templateUrl: './get-calendar-summary-organisation-table.component.html',
    styleUrls: [
        './get-calendar-summary-organisation-table.component.scss'
    ],
    standalone: false
})
export class GetCalendarSummaryOrganisationTableComponent
  extends AlternativeDatatablesComponent
  implements AlternativeDatatablesInterface, OnInit, OnDestroy, AfterViewInit {

  public readonly head = [
    {'name': 'organisation_subagent_manager_id', 'value': '', 'caption': 'Ответственный', 'width': '', 'sort': true},
    {'name': 'organisation_caption', 'value': '', 'caption': 'Организация', 'width': '280px', 'sort': true},
    {'name': 'organisation_address', 'value': '', 'caption': 'Адрес', 'sort': true},
    {'name': 'organisation_inn', 'value': '', 'caption': 'ИНН', 'width': '', 'sort': true},
    {'name': 'organisation_author', 'value': '', 'caption': 'Автор', 'width': '', 'sort': true},
    {'name': 'count_leads', 'value': '', 'caption': 'Заявок', 'width': '', 'sort': false},
    {'name': 'count_leads_db', 'value': '', 'caption': 'Бронирований', 'width': '', 'sort': false},
    {'name': 'new_org', 'value': '', 'caption': 'Новые организации', 'width': '', 'sort': false},
    {'name': 'event_list', 'value': '', 'caption': 'События', 'width': '280px', 'sort': false},
  ];
  public filter_columns = {};
  public form: UntypedFormGroup;
  public filter: string;

  private parasites = true;

  public filterSubject: Subject<void> = new Subject<void>();
  private filterSubscription: Subscription;
  private formSubscription: Subscription;

  public current_page = 1;

  public count;
  public rows;
  public thisDate = new Date();

  public sort: {[key: string]: string} = {};

  private default_query = {};

  public set data(value) {
    this.count = value['count'];
    this.rows = value['rows'];
  }

  constructor(private router: Router, private fb: UntypedFormBuilder, public activatedRoute: ActivatedRoute,
              public goBack: GoBackButtonService, private b: BreadcrumbsService,
              public http: JsonClientService) {
    super(router, activatedRoute, fb, http);

    this.filterSubscription = this.filterSubject
      .pipe(debounceTime(500))
      .subscribe(_ => this.onFilterChanges());

    this.head = this.head.map(x => {
      x.value = this.activatedRoute.snapshot.queryParams[x.name] || x.value;
      return x;
    });
    if (this.activatedRoute.snapshot.queryParams['sort_name']) {
      this.sort[this.activatedRoute.snapshot.queryParams['sort_name']] = this.activatedRoute.snapshot.queryParams['sort_key'];
    }
  }

  ngOnInit() {
    this.b.set([
      {url: '/', caption: 'Главная'},
      {url: '/analytic/index', caption: 'Аналитика'},
    ]);

    this.default_query = {
      'date_start': this.activatedRoute.snapshot.queryParams['date_start'],
      'date_end': this.activatedRoute.snapshot.queryParams['date_end'],
      'month': this.activatedRoute.snapshot.queryParams['month'],
      'new': this.activatedRoute.snapshot.queryParams['new'],
      'resale': this.activatedRoute.snapshot.queryParams['resale'],
      'method': this.activatedRoute.snapshot.queryParams['method'],
      'stage': this.activatedRoute.snapshot.queryParams['stage'],
    };

    const newoneHelp = this.default_query['new'] ? ' <p><b>НОВЫЕ</b> (Зарегистрированные за последние 3 месяца)</p>' : '';

    if (this.activatedRoute.snapshot.queryParams['stage'] === 'cnt_orgs_events_subscribe') {
      this.goBack.header = '<h4 class="mb-0"><b>Обучение</b> ' + this.default_query['month'] + '</h4><h1>Организации - Записавшиеся на все типы обучения </h1>' + newoneHelp;
    } else if (this.activatedRoute.snapshot.queryParams['stage'] === 'cnt_orgs_events_visit') {
      this.goBack.header = '<h4 class="mb-0"><b>Обучение</b> ' + this.default_query['month'] + '</h4><h1>Организации - Посетившие все типы обучения </h1>' + newoneHelp;
    } else if (this.activatedRoute.snapshot.queryParams['stage'] === 'cnt_orgs_events_not_visit') {
      this.goBack.header = '<h4 class="mb-0"><b>Обучение</b> ' + this.default_query['month'] + '</h4><h1>Организации - Отсуствующие на обучение </h1>' + newoneHelp;
    } else if (this.activatedRoute.snapshot.queryParams['stage'] === 'cnt_org_subscribe_training') {
      this.goBack.header = '<h4 class="mb-0"><b>Обучение</b> ' + this.default_query['month'] + '</h4><h1>Организации - Записавшиеся на семинары </h1>' + newoneHelp;
    } else if (this.activatedRoute.snapshot.queryParams['stage'] === 'cnt_org_visit_training') {
      this.goBack.header = '<h4 class="mb-0"><b>Обучение</b> ' + this.default_query['month'] + '</h4><h1>Организации - Посетившие семинары </h1>' + newoneHelp;
    } else if (this.activatedRoute.snapshot.queryParams['stage'] === 'cnt_org_not_visit_training') {
      this.goBack.header = '<h4 class="mb-0"><b>Обучение</b> ' + this.default_query['month'] + '</h4><h1>Организации - Отсуствующие на семинарах </h1>' + newoneHelp;
    } else if (this.activatedRoute.snapshot.queryParams['stage'] === 'cnt_org_subscribe_webinar') {
      this.goBack.header = '<h4 class="mb-0"><b>Обучение</b> ' + this.default_query['month'] + '</h4><h1>Организации - Записавшиеся на вебинары </h1>' + newoneHelp;
    } else if (this.activatedRoute.snapshot.queryParams['stage'] === 'cnt_org_visit_webinar') {
      this.goBack.header = '<h4 class="mb-0"><b>Обучение</b> ' + this.default_query['month'] + '</h4><h1>Организации - Посетившие вебинары </h1>' + newoneHelp;
    } else if (this.activatedRoute.snapshot.queryParams['stage'] === 'cnt_org_not_visit_webinar') {
      this.goBack.header = '<h4 class="mb-0"><b>Обучение</b> ' + this.default_query['month'] + '</h4><h1>Организации - Отсуствующие на вебинарах </h1>' + newoneHelp;
    } else if (this.activatedRoute.snapshot.queryParams['stage'] === 'cnt_org_subscribe_info_tour') {
      this.goBack.header = '<h4 class="mb-0"><b>Обучение</b> ' + this.default_query['month'] + '</h4><h1>Организации - Записавшиеся на мероприятия </h1>' + newoneHelp;
    } else if (this.activatedRoute.snapshot.queryParams['stage'] === 'cnt_org_visit_info_tour') {
      this.goBack.header = '<h4 class="mb-0"><b>Обучение</b> ' + this.default_query['month'] + '</h4><h1>Организации - Посетившие мероприятия </h1>' + newoneHelp;
    } else if (this.activatedRoute.snapshot.queryParams['stage'] === 'cnt_org_not_visit_info_tour') {
      this.goBack.header = '<h4 class="mb-0"><b>Обучение</b> ' + this.default_query['month'] + '</h4><h1>Организации - Отсуствующие на мероприятиях </h1>' + newoneHelp;
    } else if (this.activatedRoute.snapshot.queryParams['stage'] === 'total_new_org_events_subscribe') {
      this.goBack.header = '<h4 class="mb-0"><b>Обучение</b> ' + this.default_query['month'] + '</h4><h1>Организации - Новые записавшиеся на все типы обучения </h1>' + newoneHelp;
    } else if (this.activatedRoute.snapshot.queryParams['stage'] === 'total_new_org_events_visit') {
      this.goBack.header = '<h4 class="mb-0"><b>Обучение</b> ' + this.default_query['month'] + '</h4><h1>Организации - Новые посетившие все типы обучения </h1>' + newoneHelp;
    } else if (this.activatedRoute.snapshot.queryParams['stage'] === 'total_new_org_events_not_visit') {
      this.goBack.header = '<h4 class="mb-0"><b>Обучение</b> ' + this.default_query['month'] + '</h4><h1>Организации - Новые отсуствующие на обучение </h1>' + newoneHelp;
    } else if (this.activatedRoute.snapshot.queryParams['stage'] === 'new_org_subscribe_training') {
      this.goBack.header = '<h4 class="mb-0"><b>Обучение</b> ' + this.default_query['month'] + '</h4><h1>Организации - Новые записавшиеся на семинары </h1>' + newoneHelp;
    } else if (this.activatedRoute.snapshot.queryParams['stage'] === 'new_org_visit_training') {
      this.goBack.header = '<h4 class="mb-0"><b>Обучение</b> ' + this.default_query['month'] + '</h4><h1>Организации - Новые посетившие семинары </h1>' + newoneHelp;
    } else if (this.activatedRoute.snapshot.queryParams['stage'] === 'new_org_not_visit_training') {
      this.goBack.header = '<h4 class="mb-0"><b>Обучение</b> ' + this.default_query['month'] + '</h4><h1>Организации - Новые отсуствующие на семинарах </h1>' + newoneHelp;
    } else if (this.activatedRoute.snapshot.queryParams['stage'] === 'new_org_subscribe_webinar') {
      this.goBack.header = '<h4 class="mb-0"><b>Обучение</b> ' + this.default_query['month'] + '</h4><h1>Организации - Новые записавшиеся на вебинары </h1>' + newoneHelp;
    } else if (this.activatedRoute.snapshot.queryParams['stage'] === 'new_org_visit_webinar') {
      this.goBack.header = '<h4 class="mb-0"><b>Обучение</b> ' + this.default_query['month'] + '</h4><h1>Организации - Новые посетившие вебинары </h1>' + newoneHelp;
    } else if (this.activatedRoute.snapshot.queryParams['stage'] === 'new_org_not_visit_webinar') {
      this.goBack.header = '<h4 class="mb-0"><b>Обучение</b> ' + this.default_query['month'] + '</h4><h1>Организации - Новые отсуствующие на вебинарах </h1>' + newoneHelp;
    } else if (this.activatedRoute.snapshot.queryParams['stage'] === 'new_org_subscribe_info_tour') {
      this.goBack.header = '<h4 class="mb-0"><b>Обучение</b> ' + this.default_query['month'] + '</h4><h1>Организации - Новые записавшиеся на мероприятия </h1>' + newoneHelp;
    } else if (this.activatedRoute.snapshot.queryParams['stage'] === 'new_org_visit_info_tour') {
      this.goBack.header = '<h4 class="mb-0"><b>Обучение</b> ' + this.default_query['month'] + '</h4><h1>Организации - Новые посетившие мероприятия </h1>' + newoneHelp;
    } else if (this.activatedRoute.snapshot.queryParams['stage'] === 'new_org_not_visit_info_tour') {
      this.goBack.header = '<h4 class="mb-0"><b>Обучение</b> ' + this.default_query['month'] + '</h4><h1>Организации - Новые отсуствующие на мероприятиях </h1>' + newoneHelp;
    }

    this.filter_columns = Object.assign({}, this.default_query);

    this.form = this.fb.group({});

    this.formSubscription = this.form.valueChanges
      .subscribe(_ => this.filterSubject.next());

    for (const el of this.head) {
      this.form.addControl(el.name, new UntypedFormControl(el.value));
    }

    this.filter = this.activatedRoute.snapshot.queryParams['global_search_string'] || '';
    this.onInitCall();
  }

  ngOnDestroy() {
    super.ngOnDestroy();

    if (this.filterSubscription) {
      this.filterSubscription.unsubscribe();
    }

    if (this.formSubscription) {
      this.formSubscription.unsubscribe();
    }
  }

  onFilterChanged(): void {
    this.filter = this.activatedRoute.snapshot.queryParams['global_search_string'] || '';
    this.data = this.activatedRoute.snapshot.data['data'];
    this.current_page = +this.activatedRoute.snapshot.queryParams['page'] || 1;
    this.b.set([
      {url: '/', caption: 'Главная'},
      {url: '/analytic/index', caption: 'Аналитика'},
    ]);
  }

  onFilterChanges(text = null) {

    if (text !== null) {
      this.filter = text;
    }

    this.filter_columns = Object.assign({}, this.default_query);
    for (const el of this.head) {
      if (!this.form.get(el.name).value.length) {
        continue;
      }

      this.filter_columns[el.name] = this.form.get(el.name).value;
    }
    if (this.filter !== '') {
      this.filter_columns['global_search_string'] = this.filter;
    }
    if (this.sort) {
      this.filter_columns['sort_name'] = Object.keys(this.sort)[0];
      this.filter_columns['sort_key'] = this.sort[this.filter_columns['sort_name']];
    }
    if (this.parasites) {
      return this.parasites = !this.parasites;
    }

    this.router.navigate(['analytic', 'calendar-summary-organisation', 'table'], {
      queryParams: this.getQueryParams(),
    });
  }

  getQueryParams() {
    const query_params = Object.assign({}, this.default_query);
    for (const el of this.head) {
      if (!this.form.get(el.name).value.length) {
        continue;
      }
      query_params[el.name] = this.form.get(el.name).value;
    }
    if (this.sort) {
      query_params['sort_name'] = Object.keys(this.sort)[0];
      query_params['sort_key'] = this.sort[query_params['sort_name']];
    }
    if (this.filter !== '') {
      query_params['global_search_string'] = this.filter;
    }
    return query_params;
  }

  prepareSort(column_name: string) {
    for (const key in this.sort) {
      if (column_name !== key) {
        delete this.sort[key];
      }
    }
  }

  sortChange(column_name: string) {
    this.prepareSort(column_name);
    this.sort[column_name] = !this.sort[column_name] || ('desc' === this.sort[column_name]) ? 'asc' : 'desc';
    this.onFilterChanges();
  }
  ngAfterViewInit() {
    this.goBack.goScroll();
  }
}
